import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=2ff62402&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"
import style0 from "./Quote.vue?vue&type=style&index=0&id=2ff62402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff62402",
  null
  
)

export default component.exports